/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


// (function() {

//   // Below are example event listeners.  They listen for theme events that Pipeline
//   // fires in order to make it easier for you to add customizations.

//   // Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.


//   document.addEventListener('theme:variant:change', function(event) {
//     // You might use something like this to write a pre-order feature or a
//     // custom swatch feature.
//     var variant = event.detail.variant;
//     var container = event.target;
//     if (variant) {
//       console.log('Container ———————— ↓');
//       console.log(container);
//       console.log('Variant —————————— ↓');
//       console.log(variant);
//       // ... update some element on the page
//     }
//   });

//   document.addEventListener('theme:cart:change', function(event) {
//     var cart = event.detail.cart;
//     if (cart) {
//       console.log('Cart ———————————— ↓');
//       console.log(cart);
//       // ... update an app or a custom shipping caluclator
//     }
//   });
//   // Fired when page loads to update header values
//   document.addEventListener('theme:cart:init', (e) => {
//     console.log('theme:cart:init');
//     console.log(e);
//   });

//   // Debounced scroll listeners.  Up and down only fire on direction changes
//   // These events are useful for creating sticky elements and popups.
//   document.addEventListener('theme:scroll', e => { console.log(e); });
//   document.addEventListener('theme:scroll:up', e => { console.log(e); });
//   document.addEventListener('theme:scroll:down', e => { console.log(e); }); 

//   // Debounced resize listener to bundle changes that trigger document reflow
//   document.addEventListener('theme:resize', e => { console.log(e); });

//   // Locks and unlocks page scroll for modals and drawers
//   // These are commented out because firing them will lock the page scroll
//   // the lock event must set `detail` to the modal or drawer body so the 
//   // scroll locking code knows what element should maintain scoll. 
//   // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
//   // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


//   // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
//   // variables into the global scope.



  
// })();

 //custom functions

  const helpers = {
    appendCSS(css) {
      const styleEl = document.createElement('style');
      styleEl.innerHTML = css;
      document.body.appendChild(styleEl);
    }
  }


  const priceElement = document.querySelector('.product__price [data-product-price]');
  const addToCartButtons = document.querySelectorAll('.btn--add-to-cart [data-button-price]');
  
  if (priceElement && addToCartButtons.length) {
    const observer = new MutationObserver(() => {
      const addToCartButtons = document.querySelectorAll('.btn--add-to-cart [data-button-price]');
      addToCartButtons.forEach(btn => {
        btn.textContent = priceElement.textContent;
      })
    });
  
    observer.observe(priceElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  
    addToCartButtons.forEach(btn => {
      btn.textContent = priceElement.textContent;
    })
  }

document.addEventListener('DOMContentLoaded', function () {
  console.log({ document, a: document.querySelector('.accordion-toggle') }); 
  const accordionBtn = document.querySelector('.accordion-toggle');
  if (!accordionBtn) return;
  const accordionItem = accordionBtn.closest('.accordion-item');
  const accordionContent = accordionItem.querySelector('.accordion-content');

  accordionBtn.addEventListener('click', function () {
    const isOpen = accordionItem.classList.contains('open');

    accordionItem.classList.toggle('open');
    accordionBtn.setAttribute('aria-expanded', !isOpen);
  });


  const hideSizesFromProduct = {
    init(hiddenSizes, callback) {
      this.productContainer = document.querySelector('.product-page');
      this.hiddenSizesString = this.productContainer?.querySelector('#hiddenSizesJson');
      if (!this.hiddenSizesString) {
        return helpers.appendCSS(`.size-selector {opacity: 1;}`);
      };
      this.hiddenSizes = hiddenSizes;
      this.initialCallback = callback;
      this.formattedHiddenSizes = this.hiddenSizes.map(size => size.replaceAll(" ", ""));
      this.runInterval();
    },

    runInterval() {
      const interval = setInterval(() => {
        const executed = this.hideSizes();
        if (executed) {
          if (this.initialCallback) this.initialCallback();
          clearInterval(interval);
        }
      }, 1000);
    },

    hideSizes(hiddenSizes) {
      let formattedHiddenSizes = this.formattedHiddenSizes?.length ? [...this.formattedHiddenSizes] : [];
      if (hiddenSizes?.length){
        formattedHiddenSizes = [...hiddenSizes, ...formattedHiddenSizes];
      }
      this.sizeSelectorDiv = document.querySelector('.size-selector'); 
      this.sizeSelector = this.sizeSelectorDiv?.querySelector('select');
      if (!this.sizeSelectorDiv || !this.sizeSelector) return;
      this.sizeSelectorOptions = [...this.sizeSelector.options];

      this.sizeSelectorOptions.forEach(opt => {
        const text = opt.text;
        const formattedText = text.replaceAll(" ", "").replace("inches", "");
        if (formattedHiddenSizes.includes(formattedText)){
          opt.style.display = "none";
          opt.disabled = true;
          const event = new Event("change");
          
          if (this.sizeSelector.selectedOptions[0] === opt) {
            const firstAvailableOption = this.sizeSelectorOptions.find(x => !x.disabled && !!x.value);
            this.sizeSelector.value = firstAvailableOption.value;
            this.sizeSelector.dispatchEvent(event);
          }
        } else {
          opt.style.display = "block";
          opt.disabled = false;
          const event = new Event("change");
        }
      });

      helpers.appendCSS(`.size-selector {opacity: 1;}`);

      return 1;
    }
  }
  
  
  const imageUpdateAndHideSizeWithAPO = {
    init() {
     this.APOAppBlock = document.querySelector('#mw-apo-app-block');
     this.mediaThumbs = [...document.querySelectorAll('.media__thumb__wrapper .media__thumb img')];
     this.state = {
       mediaOption: null,
       frameColor: null
     }
      
     this.hiddenSizesJsonEl = document.querySelector('#hiddenSizesJson');

     if (this.hiddenSizesJsonEl) {
       this.handleHiddenSizes();
     } else {
        helpers.appendCSS(`.size-selector {opacity: 1;}`);
     }
      
     if(!this.APOAppBlock) return; 
     this.runInterval();
     this.setupEventListeners();
    },

    handleHiddenSizes() {
      const hiddenSizesString = this.hiddenSizesJsonEl.innerHTML;
      this.hiddenSizesData = hiddenSizesString ? JSON.parse(hiddenSizesString) : null;
      console.log({ x: this.hiddenSizesData });
      if (this.hiddenSizesData) {
        hideSizesFromProduct.init(this.hiddenSizesData.general || [], (this.hiddenSizesData?.rolled?.length ? () => hideSizesFromProduct.hideSizes(this.hiddenSizesData.rolled) : null));
      } 
    },

    updateState(newData) {
      this.state = {
        ...this.state,
        ...newData
      }
      this.render();
    },

    runInterval() {
      const interval = setInterval(() => {
        const executed = this.setupEventListeners();
        if (executed) {
          clearInterval(interval);
        }
      }, 1000);
    },

    setupEventListeners() {
      this.mediaOptionsSelectorDiv = document.querySelector('.media-options-selector');
      this.frameColorSelectorDiv = document.querySelector('.frame-color-selector');
      if (!this.mediaOptionsSelectorDiv) return;
      this.mediaOptionsSelect = this.mediaOptionsSelectorDiv.querySelector('.mw-option__control--type-select');
      this.frameColorSelect = this.frameColorSelectorDiv.querySelector('.mw-option__control--type-select');

      this.mediaOptionsSelect.addEventListener('change', this.handleMediaOptionChange.bind(this));
      this.frameColorSelect.addEventListener('change', this.frameColorSelectChange.bind(this));
      return 1;
    },

    handleMediaOptionChange(e) {
      const selectedOption = e.target.selectedOptions[0];
      const selectedOptionText = selectedOption.textContent.trim();
      this.updateState({ mediaOption: selectedOptionText });
      this.hideSizes(selectedOptionText.split(" ")[0].toLowerCase() ?? []);
    },

    frameColorSelectChange(e) {
      const selectedOption = e.target.selectedOptions[0];
      const selectedOptionText = selectedOption.textContent.trim();
      this.updateState({ frameColor: selectedOptionText });
    },

    render() {
      const { mediaOption, frameColor } = this.state;
      if (!mediaOption) return;
      if (mediaOption.includes("Rolled")) {
        const media = this.mediaThumbs.find(thumb => thumb.src.includes("Rolled"));
        if (media) media.click();
      } else if (mediaOption.includes("Framed")) {
        const media = this.mediaThumbs.find(thumb => (thumb.src.includes("Framed") || thumb.src.includes("Frame")) && thumb.src.includes(frameColor));
        if (media) media.click();
      } else if (mediaOption.includes("Canvas")) {
        const media = this.mediaThumbs.find(thumb => thumb.src.includes("Canvas"));
        if(media) media.click();
      }  else if (mediaOption.includes("Metal")) {
        const media = this.mediaThumbs.find(thumb => thumb.src.includes("Metal"));
        if(media) media.click();
      }
    },

    hideSizes(selectedOption) {
      if (!selectedOption) return;
      const hiddenSizes = this.hiddenSizesData?.[selectedOption] ?? [];
      hideSizesFromProduct.hideSizes(hiddenSizes.map(x => x.replaceAll(" ", "")));
    }

  }

  window.imageUpdateAndHideSizeWithAPO = imageUpdateAndHideSizeWithAPO;
  imageUpdateAndHideSizeWithAPO.init();
  
});



const productMediaZoomApp = {
  init() {
    this.productPage = document.querySelector('.product-page');
    if (!this.productPage) return;

    this.imageMedias = this.productPage.querySelectorAll('.product__media');

    this.setupEventListeners();
  },

  setupEventListeners() {
    this.imageMedias.forEach(image => image.addEventListener('dblclick', this.handleDbClick.bind(this)));
  },

  handleDbClick(event) {
    const media = event.currentTarget;
    const zoomButton = media.querySelector('.media__button--zoom');
    zoomButton.click();
  }
}

productMediaZoomApp.init();